import { catchError, firstValueFrom, of, Subject, switchMap, tap, throwError, timer, } from 'rxjs';
import { ProviderDataAdapter } from '../../provider-data-adapter';
import { createClientAndSyncChain } from '../create-client-and-sync-chain';
export class WalletConnectV2Adapter {
    get info() {
        return this.providerDetail.info;
    }
    constructor(providerDetail) {
        this.providerDetail = providerDetail;
        this.provider = null;
        this.connectionUriLink$ = new Subject();
        this.client = null;
        this.data = new ProviderDataAdapter(this.providerDetail.info);
    }
    async isConnected() {
        return this.provider?.isConnected() ?? false;
    }
    async createProvider() {
        const provider = new (await import('./multi-connect-provider')).MultiConnectProvider();
        provider.connectionUriLink$
            .pipe(tap((uri) => this.connectionUriLink$.next(uri)), catchError(() => of(null)))
            .subscribe();
        return provider;
    }
    async connect(chainId, opts) {
        if (!this.provider) {
            const provider = await this.createProvider();
            await provider.connect(opts);
            this.client = await createClientAndSyncChain(chainId, provider);
            this.data.setProvider(provider);
            this.provider = provider;
        }
        else {
            await this.provider.connect(opts);
        }
        return true;
    }
    async restoreConnect() {
        if (!this.provider) {
            const provider = await this.createProvider();
            await provider.restoreConnect();
            this.client = await createClientAndSyncChain(provider.chainId, provider);
            this.data.setProvider(provider);
            this.provider = provider;
        }
        else {
            await this.provider.restoreConnect();
        }
        return true;
    }
    async disconnect(address) {
        await this.provider?.disconnect(address);
        return true;
    }
    async changeChain(chainId) {
        await this.client?.switchChain({ id: chainId });
        return true;
    }
    setActiveAddress(address) {
        this.provider?.setActiveAddress(address);
    }
    async writeContract(params) {
        if (!(await this.isConnected()) || !this.client) {
            throw new Error('Wallet not connected');
        }
        const address = (await this.data.getActiveAddress());
        return await Promise.any([
            this.client.writeContract({
                ...params,
                account: address,
            }),
            firstValueFrom(timer(60 * 1000 * 3).pipe(
            // 3 min
            switchMap(() => throwError(() => new Error('wallet connect request timed out'))))),
        ]);
    }
    async signTypedData(typeData) {
        if (!(await this.isConnected()) || !this.client) {
            throw new Error('Wallet not connected');
        }
        const address = (await this.data.getActiveAddress());
        return await Promise.race([
            this.client.signTypedData({
                ...typeData,
                account: address,
            }),
            firstValueFrom(timer(60 * 1000 * 3).pipe(
            // 3 min
            switchMap(() => throwError(() => new Error('wallet connect request timed out'))))),
        ]);
    }
    connectionUriLink() {
        return this.connectionUriLink$.asObservable();
    }
    async isSupportConnectionUriLink() {
        return true;
    }
}
//# sourceMappingURL=wallet-connect-v2-adapter.js.map